import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { Stack } from '@packages/shared';
import { useIntl } from 'react-intl';
import { AdditionalServicesFragmentFragmentDoc } from '@packages/gql/generated/shopping/AdditionalServicesFragmentFragmentDoc';
import { additionalServicesMessages } from './messages';
import type { AdditionalInfoItemProps } from '../AdditionalInfoItem';
import { AdditionalInfoItem } from '../AdditionalInfoItem';
import { getValidInfoList } from '../getValidInfoList';

/* GraphQL */ `
  fragment AdditionalServicesFragment on AdditionalServicesInfo {
    infoList {
      serviceLayerId
      translationKey
      iconUrl
    }
  }
`;

export type AdditionalServicesProps = {
  data: FragmentType<typeof AdditionalServicesFragmentFragmentDoc>;
} & Pick<AdditionalInfoItemProps, 'dialogTitle'>;

export const AdditionalServices = ({ data, dialogTitle }: AdditionalServicesProps) => {
  const { infoList } = getFragmentData(AdditionalServicesFragmentFragmentDoc, data);
  const { formatMessage } = useIntl();

  if (infoList.length === 0) return null;

  const validInfoList = getValidInfoList(infoList, additionalServicesMessages);

  if (validInfoList.length === 0) return null;

  return (
    <Stack spacing={2} alignItems="flex-start">
      {validInfoList.map((item, index) => (
        <AdditionalInfoItem
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          icon={item.iconUrl}
          serviceLayerId={item!.serviceLayerId}
          text={formatMessage(item.messageDescriptor, {
            bold: (chunks: React.ReactNode) => <b>{chunks}</b>,
          })}
          dialogTitle={dialogTitle}
        />
      ))}
    </Stack>
  );
};
